exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1024px){.mobile-only[data-v-64344feb]{display:none !important}}@media (max-width: 1023px){.desktop-only[data-v-64344feb]{display:none !important}}.m-product-options-group[data-v-64344feb]{margin:0 var(--spacer-sm)}@media (min-width: 1024px){.m-product-options-group[data-v-64344feb]{margin:0 var(--spacer-xl)}}.m-product-options-group[data-v-64344feb]  .sf-grouped-product-item__aside{display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end}.sku[data-v-64344feb]{color:#a3a5ad}\n", ""]);

// exports
